import { Key, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "react-router-dom";
import { trackEvent } from "../../appInsights/TelemetryService";
import { useDispatch, useSelector } from "react-redux";
import { RepairStatusField } from "../../models/Repair/Repair";
import * as api from "../../api";
import { formatDateWithFromCalendar } from "../../utils/formatting";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { PermissionsList } from "../../models/Permissions";
import {
  componentInformation,
  defaultAssetId,
  resumeDraftRepair,
  userResumeDraftDataCache,
  loadDuplicateRepairPage,
  workOrderData, userChosenIsSurvey, userChosenCustomerID,
  woFailureCase
} from "../../ducks/redux/actions/userChoices";
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import { SurveyTypes } from "../../models/shared/Enum";
import { priorityCode } from "../../ducks/redux/actions/dashboardReducer.actions";
import woImg from '../../assets/icons/Work-order-type-Survey.png';
import '../../utils/commonCss/icons.css'
import useBackToTop from "../BackToTop/useBackToTop";
import { getPreviousPageName, storeAPIErrors } from "../../ducks/redux/actions/FinancialReferral";
import { getWorksOrdersApi } from "../APIErrorComponent/APIConstantName";
import { addAPIError, removeAPIError } from "../../utils/translation/helper";
import ErrorComponent from "../APIErrorComponent/ErrorComponent";

interface WorkCardProps extends RouteComponentProps<any> { }
const WorkCard: React.FC<WorkCardProps> = (props) => {
  const { t } = useTranslation();
  let arrayErrorCode: string[] = [];
  let [errorCodeArray, setErrorCodeArray] = useState(arrayErrorCode);
  const [dropDown, setDropDown] = useState("none");
  const getPermissionsData = useSelector(
    (state: any) => state?.userChoicesReducer?.userProfilePermissions
  );
  const viewWorkOrderList = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.view_work_order_list);
  const { width } = useBackToTop();
  const tenancySummaryList = (state: any) =>
    state?.addresses?.tenancysummarylist;

  let selectedTenacyType = useSelector(
    (state: any) => state?.addresses?.selectedTenancy
  );

  let assetStatus = useSelector(
    (state: any) => state.userChoicesReducer?.assetDataStatus
  );
  const isActiveTenancy = useSelector(
    (state: any) => state?.userChoicesReducer?.isActiveTenancy
  );
  const assetDetails = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.assetByIdDataObject
  );
  const isP360Maintainence = useSelector(
    (state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
  );
  const tenancySummaryData = useSelector(tenancySummaryList);
  const [workOrderList, setWorkOrderList]: any = useState();

  const [isCreateSurvey, setIsCreateSurvey] = useState(false);
  const dispatch = useDispatch();

  const customerId = useSelector(
    (state: any) => state?.userChoicesReducer?.custommerID
  );
  const errors = useSelector((state: any) => state.financialReferralReducer?.APIerrors);
  const [apiFailureError, setApiFailureError] = useState(false);

  const currentAssetEligibilityDetails = useSelector(
    (state: any) => state?.addresses?.currentAssetEligibilityDetails
  );

  useEffect(() => {
    trackEvent("WorkSummaryCard");
    dispatch(componentInformation("Asset360"));
    const createSurvey = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.create_p360_surveying1);
    setIsCreateSurvey(createSurvey);

    callWorkOrderApi();
    noWorkOrderFunction();
  }, [assetDetails]);

  let errorData: any = [];
  function callWorkOrderApi() {
    (async () => {
      try {
        const propertiesIds: string[] = [];
        propertiesIds.push(assetDetails?.id);
        let tenancyStartDate =
          tenancySummaryData === undefined
            ? ""
            : tenancySummaryData[0]?.tenancySummary.tenancyStartDate;
        const status =
          RepairStatusField.Appointed +
          "," +
          RepairStatusField.PendingApproval +
          "," +
          RepairStatusField.OnHold +
          "," +
          RepairStatusField.Cancelled +
          "," +
          RepairStatusField.Completed +
          "," +
          RepairStatusField.Unappointed +
          "," +
          RepairStatusField.InProgress +
          "," +
          RepairStatusField.InDiagnosis +
          "," +
          RepairStatusField.ReportedToEMA +
          "," +
          RepairStatusField.CatalystTier2Triage +
          "," +
          RepairStatusField.CatalystEMAStatus +
          "," +
          RepairStatusField.CatalystDefectTriage +
          "," +
          RepairStatusField.isPendingAssessment;
        let queryParams: any;
        if (assetDetails?.id) {
          queryParams = {
            propertiesIds: propertiesIds,
            orderBy: "raisedDate desc",
            raisedSince: tenancyStartDate,
            priority: "",
            status,
            limit: 2,
            isTriage: ""
          };
        }
        const worksOrdersRepair = await api.getWorksOrdersApi(queryParams);
        errorData = removeAPIError(getWorksOrdersApi, errors);
        worksOrdersRepair.worksOrders.forEach((wo: any) => {
          if (wo.job.description === "Inspect Damp and Mould") {
            wo.job.description = "Investigate damp or mould";
          }
        });
        dispatch(userChosenCustomerID(worksOrdersRepair?.worksOrders[0]?.identifiers?.customerIdentifier || customerId));
        setWorkOrderList(worksOrdersRepair);
        setApiFailureError(false);
      } catch (e) {
        console.error(e);
        errorData = addAPIError(getWorksOrdersApi, errors);
        setApiFailureError(true);
        setWorkOrderList({
          worksOrders: [
            {
              job: { workProgramme: '-', trade: '-' },
              asset: { type: { assetTypeName: '-' } },
              raisedDate: '',
              statuses: { status: '-' },
            },
            {
              job: { workProgramme: '-', trade: '-' },
              asset: { type: { assetTypeName: '-' } },
              raisedDate: '',
              statuses: { status: '-' },
            }
          ]
        });
      }
      dispatch(storeAPIErrors(errorData))
    })();
  }

  const callWorkOrder360 = (workOrder: any) => {
    if (workOrder.job.description === "Inspect Damp and Mould") {
      workOrder.job.description = "Investigate damp or mould";
    }
    dispatch(workOrderData(workOrder));
    props.history.push(`/WorkOrder360View/${workOrder.identifiers.worksOrderIdentifier}`);
  };

  const callWorkOrderPage = () => {
    dispatch(defaultAssetId(assetDetails?.id));
    props.history.push("/AssetWorkOrderResult");
  };

  const dropDownFunction = () => {
    if (dropDown === "none") setDropDown("block");
    else setDropDown("none");
  };

  function noWorkOrderFunction() {
    const tempArray = t("no_work_order_txt").split("?");
    setErrorCodeArray(tempArray);
  }
  const callPageHandler = () => {
    if (!isP360Maintainence) {
      dispatch(workOrderRepairObject(null));
      dispatch(resumeDraftRepair(false));
      dispatch(userResumeDraftDataCache(null));
      dispatch(loadDuplicateRepairPage(false));
      dispatch(getPreviousPageName(selectedTenacyType))
      dispatch(priorityCode(''));
      dispatch(woFailureCase());
      props.history.push("/RepairAsset", { previousPathname: globalThis.location.pathname });
    }
  };
  const callSurveyHandler = () => {
    if (!isP360Maintainence) {
      dispatch(userChosenIsSurvey(true));
      props.history.push("/SurveyAsset");
    }
  };

  const showRepair = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.create_repair_standard);

  const isKebabMenuVisible = ((showRepair) || isCreateSurvey) &&
    ((selectedTenacyType === "Property" && isActiveTenancy) ||
      (selectedTenacyType === "Property" && (assetStatus === 'OCCP' || assetStatus === 'VOID')) ||
      selectedTenacyType === "Divided Block" ||
      selectedTenacyType === "Block" ||
      selectedTenacyType === "Estate");

  const shouldShowRepairOption = currentAssetEligibilityDetails?.isEligibleToRaiseARepair && (showRepair && (selectedTenacyType === "Property"
    ? (isActiveTenancy || (assetStatus === 'OCCP' || assetStatus === 'VOID')): true));

  return (
    <div>
      <div className="px-4 py-2 border-b border-grey bg-teal rounded-t-lg">
        <div className="flex flex-row d-flex bd-highlight items-center">
          <img src={woImg} className="text-white text-2xl mr-6 sm:mr-4 bd-highlight logo logoLeft" alt="" />
          <h2 className="my-0 text-white bd-highlight">
            {t("worksOrderSurveys")}
          </h2>
          {isKebabMenuVisible ? (
            <div className="menu-nav ms-auto bd-highlight">
              <div className="dropdown-container ms-auto">
                <button
                  className="three-dots kebabMenu subHeading-kebab"
                  data-testid="dropFunction"
                  onClick={dropDownFunction}
                  type={undefined}
                  aria-label="Menu"
                  aria-haspopup="true"
                ></button>
                <div
                  className="dropdown px-2 dropdown-margin py-2"
                  style={{ display: dropDown }}
                >
                  {shouldShowRepairOption? (
                    <a
                      onClick={callPageHandler}
                      data-testid="callHandler"
                      className="text-black text-base no-underline global-txt"
                    >
                      <div className={"py-2 cursor-pointer text-black text-base no-underline dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                        {selectedTenacyType === "Property"
                          ? t("Create_repair")
                          : t("raise_comm")}
                      </div>
                    </a>
                  ) : null}
                  {isCreateSurvey ? (
                    <a data-testid="surveyraise" aria-hidden="true" onClick={callSurveyHandler} className="text-black text-base no-underline global-txt">
                      <div className={"py-2 cursor-pointer text-black text-base no-underline dropdown-item " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                        {t("create_a_survey")}
                      </div>
                    </a>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      {workOrderList?.worksOrders?.length > 0 && !apiFailureError ? (
        <div className="px-4 mt-2 global-txt mb-2">
          <div className="text-dark flex justify-start">
            <div className="pr-4">
              {t("Asset_heading")}{" "}
            </div>
          </div>
        </div>
      ) : null}
      {isP360Maintainence && <div className="alert mb-0">
        <div className="alert p-0 container" role="alert">
          <div className="w-full px-3 py-2 bg-purple-20 flex items-center">
            <div className="px-4 pr-8">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" className="text-purple-100 w-6 h-6">
                <path d="M480 179.6C498.6 188.4 512 212.1 512 240C512 267.9 498.6 291.6 480 300.4V448C480 460.9 472.2 472.6 460.2 477.6C448.3 482.5 434.5 479.8 425.4 470.6L381.7 426.1C333.7 378.1 268.6 352 200.7 352H192V480C192 497.7 177.7 512 160 512H96C78.33 512 64 497.7 64 480V352C28.65 352 0 323.3 0 288V192C0 156.7 28.65 128 64 128H200.7C268.6 128 333.7 101 381.7 53.02L425.4 9.373C434.5 .2215 448.3-2.516 460.2 2.437C472.2 7.39 480 19.06 480 32V179.6zM200.7 192H192V288H200.7C280.5 288 357.2 317.8 416 371.3V108.7C357.2 162.2 280.5 192 200.7 192V192z"></path>
              </svg>
            </div>
            <div className="flex items-center">
              <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
                {t("repair_Changes")}
              </p>
            </div>
          </div>
        </div>
      </div>}
      {!workOrderList?.worksOrders?.length && !apiFailureError ? (
        <div className="w-full test-base my-2 px-4 global-txt mt-3">
          <b>{errorCodeArray[0]}</b>
          <ul className="mt-2 ml-2">
            <li className="listWithIndent"> {errorCodeArray[1]}</li><br />
            <li className="listWithIndent"> {errorCodeArray[2]}</li>
          </ul>
        </div>
      )
        : (
          workOrderList?.worksOrders.map(
            (_el: any, key: Key | null | undefined) => (
              <div key={key} className="px-4 global-txt py-2">
                <div className="border border-grey rounded-lg bg-grey">
                  <div className="bg-peach px-4 py-2 rounded-t-lg">
                    <div className={width < 820 ? "items-center" : "flex flex-row justify-between items-center"}>
                      <div className="my-0 text-lg">
                        {(_el?.statuses?.status === "-") ?
                          <strong>-</strong>
                          :
                          <strong>
                            <a
                              data-testid={"WorkOrder360Link" + _el?.identifiers?.worksOrderIdentifier}
                              className="text-dark cursor-pointer"
                              onKeyPress={() => callWorkOrder360(_el)}
                              onClick={() => callWorkOrder360(_el)}
                              role="button"
                            >
                              {t("wo")}{" "}
                              {(_el?.statuses?.status === RepairStatusField.CatalystEMATriage)
                                ? RepairStatusField.CatalystEMAStatus
                                : (_el?.statuses?.status === RepairStatusField.CatalystTier2Triage || _el?.statuses?.status === RepairStatusField.CatalystDefectTriage)
                                  ? _el?.statuses?.status
                                  : _el.identifiers?.jobNumber}
                            </a>
                          </strong>
                        }
                      </div>
                      <div className="my-0 text-lg">
                        <strong>
                          {(_el?.job?.repairType === SurveyTypes.survey)
                            ? SurveyTypes.Survey
                            : (_el?.job?.workProgramme != null &&
                              _el?.job?.workProgramme !== "" &&
                              _el?.job?.workProgramme !== undefined)
                              ? t(_el?.job?.workProgramme)
                              : t("RESP")}
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 grid grid-cols-1 md:grid-cols-2">
                    <div className="py-2 pr-4">
                      <div><b>{t("High_Level_Description")}</b></div>
                      <div >
                        {
                          _el?.job.trade === "Unknown" &&
                            _el?.channel !== RepairChannel.CustomerSelfService &&
                            _el?.channel !== RepairChannel.ERGO &&
                            _el?.channel !== RepairChannel.ColleagueSelfServe
                            ? t("RepairDescription_ErrorMessage")
                            : _el?.channel === RepairChannel.CustomerSelfService ||
                              _el?.channel === RepairChannel.ERGO ||
                              _el?.channel === RepairChannel.ColleagueSelfServe ||
                              _el?.channel === RepairChannel.Automated
                              ? _el?.job.description?.split(".")[0]
                              : _el?.job.trade}
                      </div>
                    </div>
                    <div className="py-2">
                      <div className="pr-4"><b>{t("status_txt")}</b></div>
                      <div>
                        {_el.statuses?.isPendingAssessment && _el?.assessmentInformation && _el?.job?.sorCode === t("PRODAMP") ? t("Pending_Assessment") :
                          (_el?.statuses.status === "In Diagnosis" &&
                            _el.statuses.isRaisedAsTriage)
                            ? "Under review"
                            : _el?.statuses.status === "In Diagnosis"
                              ? t("draft")
                              : (_el?.statuses.status === "Unappointed" || _el?.statuses.status === "Reported to EMA")
                                ? (_el?.job?.repairType === SurveyTypes.survey ? t("assigned_surveyor") : t("assigned_contractor"))
                                : (_el?.statuses?.status === RepairStatusField.CatalystEMATriage)
                                  ? RepairStatusField.CatalystEMAStatus
                                  : _el?.statuses.status
                        }
                      </div>
                    </div>
                    <div className="py-2">
                      <div className="pr-4"><b>{t("Date_Creation")}</b></div>
                      <div>
                        {formatDateWithFromCalendar(_el?.raisedDate)}
                      </div>
                    </div>
                    <div className="py-2 pr-4">
                      <div><b>{t("property_type_txt")}</b></div>
                      <div>
                        {_el?.asset?.type?.assetTypeName}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          )
        )}
      {workOrderList?.worksOrders?.length > 0 && viewWorkOrderList && !apiFailureError ? (
        <div className="w-full py-4 flex justify-between absolute bottom-0 px-4">
          <div>
            <a
              href=""
              data-testId="WorkOrderListLink"
              className="global-txt text-teal underline"
              onClick={callWorkOrderPage}
            >
              <b>{t("view_workorders")}</b>
            </a>
          </div>
        </div>
      ) : null}
      <ErrorComponent input={[getWorksOrdersApi]} isbottomOfDom={true} />
    </div>
  );
};
export default WorkCard;